<template>
    <Dialog v-model="dialog" width="800" title="DETALHES DA EXPIRAÇÃO" show-close-button>
        <v-data-table
                :headers="headers"
                :items="reservas"
                :items-per-page="5"
                class="custom-table"
        >
            <template v-slot:item="{ item, index }">
                <tr :class="{ 'alternate-row': index % 2 === 1 }">
                    <td v-if="!(index % 2 === 1)"></td>
                    <td>{{ item.grupo }}</td>
                    <td>{{ item.id_reserva }}</td>
                    <td>{{ item.cd_cota }}</td>
                    <td>{{ formatDate(item.dt_validade) }}</td>
                    <td>
                        <v-chip
                                label
                                :class="getExpiracaoTextColorClass(item.dias_para_expirar)"
                                :color="getBackgroundColor(item.dias_para_expirar)"
                                class="fixed-width-chip"
                        >
                            <v-icon class="mr-2" size="18">{{ getIcon(item.dias_para_expirar) }}</v-icon>
                            {{ formatarTextoDias(item.dias_para_expirar) }}
                        </v-chip>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </Dialog>
</template>

<script>
  import { format } from 'date-fns'
  import { ptBR } from 'date-fns/locale'
  import { getExpiracaoTextColorClass, getBackgroundColor, getIcon } from '@/plugins/expiracao_helpers'

  export default {
    name: 'ExpiracaoReservasModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      reservas: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        headers: [
          {
            text: '',
            width: '0px'
          },
          {
            text: 'Código do grupo',
            align: 'start',
            value: 'grupo'
          },
          {
            text: 'Número da reserva',
            value: 'id_reserva'
          },
          {
            text: 'Número da cota',
            value: 'cd_cota'
          },
          {
            text: 'Data de expiração',
            value: 'dt_validade'
          },
          {
            text: 'Status da expiração',
            value: 'dias_para_expirar'
          }
        ]
      }
    },
    computed: {
      dialog: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      getExpiracaoTextColorClass,
      getBackgroundColor,
      getIcon,
      fecharModal () {
        this.dialog = false
      },
      formatDate (date) {
        if (!date) return ''
        return format(new Date(date), 'dd/MM/yyyy', { locale: ptBR })
      },
      formatarTextoDias (dias) {
        if (dias < 0) {
          const diasExpirados = Math.abs(dias)
          return diasExpirados === 1 ? 'Expirou há 1 dia' : `Expirou há ${diasExpirados} dias`
        } else if (dias === 0) {
          return 'Expira hoje'
        } else {
          return dias === 1 ? 'Falta 1 dia' : `Faltam ${dias} dias`
        }
      }
    }
  }
</script>

<style scoped>
.custom-table {
    border-radius: 12px 15px 0px 0px;
    overflow: hidden;
}

.custom-table >>> .v-data-table-header th {
    background-color: var(--primary) !important;
    color: white !important;
    font-size: 1.2rem;
    font-weight: 500;
    padding: 15px 10px;
    justify-content: space-between;
}

.custom-table >>> tbody tr:hover {
    background-color: inherit !important;
}

.custom-table >>> .v-data-table-header th .v-icon {
    color: white !important;
}

.alternate-row {
    position: relative;
    overflow: hidden;
}

.alternate-row::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--primary);
    opacity: 0.09;
    z-index: 0;
    pointer-events: none;
    box-sizing: border-box;
}

.fixed-width-chip {
    min-width: 100px !important;
    justify-content: center !important;
}
</style>
